/** @jsxImportSource @emotion/react */

import { Global, css } from '@emotion/react'
import { Fragment, ReactElement } from 'react';
import GenJyuuGothicBoldsubsetttf from './GenJyuuGothic-Bold-subset.ttf'
import GenJyuuGothicBoldsubsetwoff from './GenJyuuGothic-Bold-subset.woff'
import GenJyuuGothicBoldsubsetwoff2 from './GenJyuuGothic-Bold-subset.woff2'
import TokubaiPriceFontFace from '../../fonts/TokubaiPriceFontFace'

function FontFace(): ReactElement {
  return (
    <Fragment>
      <TokubaiPriceFontFace />
      <Global
        styles={css`
          @font-face {
            font-family: GenJyuuGothic;
            src: url('${GenJyuuGothicBoldsubsetwoff2}') format('woff2'),
              url('${GenJyuuGothicBoldsubsetwoff}') format('woff'),
              url('${GenJyuuGothicBoldsubsetttf}') format('truetype');
            font-weight: bold;
            font-style: normal;
            font-display: swap;
          }
        `}
      />
    </Fragment>
  )
}

export const genJyuuGothicBold = css`
  font-family: GenJyuuGothic, '游ゴシック体', YuGothic, '游ゴシック', 'Yu Gothic', sans-serif;
  font-weight: bold;
`

export default FontFace
